import React from 'react'
import { PageTitle } from 'uiComponents/typography/pageElements'
import { ActionButtonA } from 'uiComponents/buttons'
import { useTranslation } from 'translations'
import './redirectPage.scss'

interface RedirectPageProps {
    oldPageTitle: string
    newPageTitle: string
    action: string
    image: string
    link: string
}

const RedirectPage: React.FC<RedirectPageProps> = ({ oldPageTitle, newPageTitle, action, image, link }) => {
    const { t } = useTranslation()
    return (
        <div className="redirect-page">
            <PageTitle>{oldPageTitle}</PageTitle>
            <div className="redirect-content">
                <img src={image} alt={oldPageTitle} />
                <span>{t('redirectPage.message', { oldPageTitle, action, newPageTitle })}</span>
                <ActionButtonA className="redirect-button" href={link}>
                    {t('redirectPage.visit', { newPageTitle })}
                </ActionButtonA>
            </div>
        </div>
    )
}

export default RedirectPage
